export const tomos = [
  {
    n: '1',
    title: 'Pilates Suelo (Matwork)',
    subtitle: 'El método original, ficha a ficha',
    description:
      '40 fichas de ejercicios, preparaciones y variantes de suelo, con referencias como Hundred, Roll Up, círculo de una pierna y Teaser. Incluye 8 clases estructuradas de 45 minutos para organizar el repertorio con un objetivo.',
    items: ['Una página por ejercicio', 'Ejecución y correcciones', 'Regresión y progresión', 'Clases y hojas imprimibles']
  },
  {
    n: '2',
    title: 'Pilates con Reformer',
    subtitle: 'Montaje, control y transiciones',
    description:
      '40 fichas con trabajo de pies, lazos, caja y plataforma de salto, más 8 clases de 45 minutos. Indicaciones de montaje, control del carro y cambios entre tareas para docentes con formación en el aparato.',
    items: ['Montaje y apoyos', 'Resistencia según persona y modelo', 'Dosis y pausas', 'Clases organizadas por bloques']
  },
  {
    n: '3',
    title: 'Cadillac y Silla',
    subtitle: 'Precisión en aparatos especializados',
    description:
      '20 fichas de Cadillac y 20 de Silla, con clases de 45 minutos por aparato. Trabajo con barras, muelles, pedal y apoyos, con indicaciones para organizar la práctica y controlar el retorno.',
    items: ['Clases separadas por aparato', 'Preparación del equipo', 'Errores y correcciones', 'Alternativas de ejecución']
  },
  {
    n: '4',
    title: 'Pilates con Accesorios',
    subtitle: 'Un accesorio, una secuencia',
    description:
      '40 fichas con aro, bandas, rodillo y pelota, y clases de 45 minutos. Secuencias centradas en un accesorio para reducir cambios de material y adaptar la dificultad con criterio.',
    items: ['Aro y bandas', 'Rodillo y pelota', 'Opciones más sencillas y progresiones', 'Clases con material organizado']
  },
  {
    n: '5',
    title: 'Pilates en Pared',
    subtitle: 'De pie, con silla y en suelo',
    description:
      '40 fichas y clases de 45 minutos que utilizan la pared como referencia y apoyo. Incluye opciones de pie, con silla y en suelo, con movilidad, control y trabajo de brazos y piernas.',
    items: ['Clases sin trabajo tumbado', 'Opciones con colchoneta', 'Ajustes de distancia y apoyo', 'Secuencias con tiempos y dosis']
  },
  {
    n: '6',
    title: 'Pilates Terapéutico y Poblaciones Especiales',
    subtitle: 'Opciones según cada valoración',
    description:
      '40 fichas de movimiento adaptable y modelos de clase de 45 minutos. Opciones sentadas, de pie con apoyo, laterales y en suelo, para seleccionar según la valoración, las posiciones toleradas y las restricciones individuales.',
    items: ['Opciones de acceso y apoyos', 'Registro de respuesta', 'Criterios para reducir o detener', 'Adaptación individual'],
    disclaimer: 'Material de apoyo docente: no sustituye valoración clínica, formación específica ni tratamiento individual.'
  }
];
